<div class="container-fluid padding-top-bottom-15 new-dashboard">
  <div class="row margin-bottom-15">
    <div class="row d-block">
      <div class="nav icn home" (click)="backtoDashboard()">Home/Email</div>
      <div class="calendar">
        <!-- <h4 class="text-capitalize">
          {{ displayName?displayName:userInfo?.info?.name?userInfo?.info?.name:'' }}'s Email
        </h4> -->
      </div>
    </div>
  </div>
</div>





<!-- <div class="card mb-2">
  <div class="d-flex flex-row justify-content-between align-items-center">
    <div class="d-flex flex-row" style="padding: 5px 10px;margin-left: 13px;">
      <a *ngIf="isScheduling" class="border mr-2 d-flex align-items-center rounded px-4 py-2 justify-content-between"
        [routerLink]="['./../../../scheduling']">Calendar <i class="pi pi-calendar px-2"
          style=" font-size: 22px; "></i></a>

      <a *ngIf="!isScheduling" class="border mr-2 d-flex align-items-center rounded px-4 py-2 justify-content-between"
        [routerLink]="['./../scheduling']">Calendar <i class="pi pi-calendar px-2" style=" font-size: 22px; "></i></a>

        <button  id="authorize_button" onclick="handleAuthClick()" type="button" class="login-with-google-btn" >
      
        
        <button id="authorize_button" onclick="handleAuthClick()" type="button" class="login-with-google-btn" >
          Sign in with Google
        </button>

        <button  class="signout_button" type="button" >Sign Out</button> -->
       
    <!-- </div> -->
    <div class="d-flex flex-row justify-content-start align-items-center" *ngIf="userInfo || profile">

    
    <div class="d-flex flex-row justify-content-start align-items-center">

  

      <div class="authenticatedProfileData" *ngIf="profile">
        <div class="d-flex align-items-center justify-content-between" *ngIf="loginDisplay">
          <div class="d-flex align-items-center justify-content-between">
            <img src="../../../../assets/microsoft-outlook.svg" class="img-style" style="width: 30px;" />
            <small class="mb-0 ml-1 d-flex flex-column">
              {{ profile?.displayName }}
              <small>{{ profile?.mail }}</small>
            </small>
          </div>
          <div class="d-flex align-items-center justify-content-around">
            <i class="pi pi-refresh pointer mx-1" title="Refresh" (click)="ngOnInit()"></i>
            <i class="pi pi-cog pointer" title="Settings" (click)="menu.toggle($event)"></i>
          </div>
        </div>
        <p-menu #menu appendTo="body" [model]="outlookSettingsMenu" [popup]="true"></p-menu>
      </div>
      <button class="btn btn-link pl-1 mb-2" type="button" *ngIf="!authService.instance.getAllAccounts().length"
        (click)="loginOutlook()">
        <img src="../../../../assets/ms-symbollockup_signin_dark.png" style=" min-width: 198px; width: 198px;">
      </button>
    </div>
  </div>
<!-- </div>  -->






<div class="card mb-2">
      

  <div class="nav nav-tabs d-flex flex-row" id="nav-tab" role="tablist">
   
    <div class="nav-item nav-link"  [ngClass]="{'active': tab.value == true}" (click)="emailRouting(tab)" *ngFor="let tab of tabArray;">
     {{tab.name}}
    </div>
 
  </div> 

</div>


<!-- IMAGILITY EMAIL -->
<div class="w-100 email-contaioner card p-2" *ngIf="tabArray[0].value == true">
 <app-unified-email-component></app-unified-email-component>
</div>

  <!-- GMAIL -->
  <div class="w-100 email-contaioner card p-2"  *ngIf="tabArray[1].value == true">

  <div class="col-md-12">
    <div class="row bg-google">
      <button  id="authorize_button" onclick="handleAuthClick()" type="button" class="login-with-google-btn float-left" >
        Sign in with Google
      </button>

      <button *ngIf="isScheduling" class="border mr-2 d-flex align-items-center rounded px-4 py-2 mt-2  float-left justify-content-between"
      [routerLink]="['./../../../scheduling']">Calendar <i class="pi pi-calendar px-2"
        style=" font-size: 22px; "></i></button>

        <button *ngIf="!isScheduling" class="border mr-2 d-flex align-items-center rounded px-4 py-2 mt-2 justify-content-between"
        [routerLink]="['./../scheduling']">Calendar <i class="pi pi-calendar px-2" style=" font-size: 22px; "></i></button>

    </div>
  </div>

  <div class="clearfix"></div>


  <div  id="spinnerGmail" class="spinner-border text-secondary my-3 mx-auto" style="width: 3rem;height: 3rem;" role="status"></div>
  <div  class="row">
    <div class="col-md-2 pull-left" style="border: 1px solid #cecece; background:#F6F8FC;" id="inboxcontainer1">

      <div class="gmailLogo">  <img src="https://ssl.gstatic.com/ui/v1/icons/mail/rfr/logo_gmail_lockup_default_1x_r5.png"></div>
      <div class="inbox_gmail">      
        <button type="button" class="composeEmail btn btn-primary" (click)="composeEmail()">Compose</button>
          <ul>
            <li class="boldTxtEmail" onclick="listLabels(event)">Inbox</li>
            <li style="display: none;">Sent</li>
            <li onclick="getDraft(event)">Drafts</li>
            <li onclick="handleSignoutClick()">Sign Out</li>
            <li></li>          
          </ul>
      </div>

    </div>

    <div class="col-md-10  pull-right">

    <div class="flex-column justify-content-center align-items-center" id="composeContainer" >
       
        <h4 class="mb-4">Compose Email</h4>
        <form style="width: 100%; text-align: center;">
        <input type="text" class="form-control mb-2" pattern="email" required placeholder="To" id="compose-to" />
        <input type="text" class="form-control mb-2" pattern="email" required placeholder="CC" id="compose-cc" />
        <input type="text" class="form-control mb-2" required placeholder="Subject" id="compose-subject" />
        <textarea class="form-control  mb-4" id="compose-message" required placeholder="Type your message here"></textarea>

        <div class="clip-upload">
          <label for="file-input">
          <i class="fa fa-paperclip fa-lg" aria-hidden="true"></i>
          <span>Attachment</span>
         </label> 
          <input  type="file" onChange="convertToBase64(event);"  accept="application/pdf" class="file-input-gmail hide" name="file-input" id="file-input">
          <div class="filename-container hide"></div>
         <div id="currentFile" style="visibility: hidden;" onclick="viewPDF()">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="48" height="46" viewBox="0 0 256 256" xml:space="preserve"><defs></defs>
            <g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;" transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)" >
              <path d="M 11.58 54.882 v 31.965 c 0 1.741 1.412 3.153 3.153 3.153 h 60.534 c 1.741 0 3.153 -1.412 3.153 -3.153 V 54.882 C 56.073 47.881 33.792 47.838 11.58 54.882 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(184,53,53); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
              <path d="M 78.42 54.882 V 18.345 C 69.386 13.658 63.133 7.61 60.075 0 H 14.733 c -1.741 0 -3.153 1.412 -3.153 3.153 v 51.729 H 78.42 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(233,233,224); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
              <path d="M 78.42 18.345 H 62.948 c -1.587 0 -2.873 -1.286 -2.873 -2.873 V 0 L 78.42 18.345 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(217,215,202); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
              <path d="M 32.116 62.679 h -5.944 c -0.829 0 -1.5 0.672 -1.5 1.5 v 9.854 v 6.748 c 0 0.828 0.671 1.5 1.5 1.5 s 1.5 -0.672 1.5 -1.5 v -5.248 h 4.444 c 2.392 0 4.338 -1.946 4.338 -4.338 v -4.177 C 36.454 64.625 34.508 62.679 32.116 62.679 z M 33.454 71.194 c 0 0.737 -0.6 1.338 -1.338 1.338 h -4.444 v -6.854 h 4.444 c 0.738 0 1.338 0.601 1.338 1.339 V 71.194 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(249,249,249); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
              <path d="M 46.109 82.28 h -5.652 c -0.829 0 -1.5 -0.672 -1.5 -1.5 V 64.179 c 0 -0.828 0.671 -1.5 1.5 -1.5 h 5.652 c 2.553 0 4.63 2.077 4.63 4.63 V 77.65 C 50.739 80.203 48.662 82.28 46.109 82.28 z M 41.957 79.28 h 4.152 c 0.898 0 1.63 -0.731 1.63 -1.63 V 67.309 c 0 -0.898 -0.731 -1.63 -1.63 -1.63 h -4.152 V 79.28 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(249,249,249); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
              <path d="M 63.828 62.679 h -8.782 c -0.828 0 -1.5 0.672 -1.5 1.5 V 80.78 c 0 0.828 0.672 1.5 1.5 1.5 s 1.5 -0.672 1.5 -1.5 v -6.801 h 4.251 c 0.828 0 1.5 -0.672 1.5 -1.5 s -0.672 -1.5 -1.5 -1.5 h -4.251 v -5.301 h 7.282 c 0.828 0 1.5 -0.672 1.5 -1.5 S 64.656 62.679 63.828 62.679 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(249,249,249); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
            </g>
            </svg>
            <div id="composeFileName"></div>
         </div>
        </div>

        <button onclick="sendEmail()" id="send-button"type="Submit" class="login-with-google-btn" style="border: 1px solid #cecece;
    font-weight: bold; margin: 0px auto;">
          Send Email
        </button>
  
        <button onclick="draftEmail()" id="draft-button" type="Submit" class="signout_button" style="margin-left: 10px; border: 1px solid #cecece;">
          Save Draft
        </button>
      </form>
      
        <div  id="successEmail" style="display: none; padding: 10px; border-radius: 10px; margin: 20px auto; margin-bottom: 0px; background: #b2e2b8; border: 2px solid #5ca065; text-align: center; color: #000; font-weight: bold;">
          Email Sent Successfully
      </div>

      <div  id="draftEmail" style="display: none; padding: 10px; border-radius: 10px; margin: 20px auto; margin-bottom: 0px; background: #b2e2b8; border: 2px solid #5ca065; text-align: center; color: #000; font-weight: bold;">
        Email Saved to Draft Successfully
      </div>

      <div  id="errorEmail" style="display: none; padding: 10px; border-radius: 10px; margin: 20px auto; margin-bottom: 0px; background:#F75757; border: 2px solid #b11e2f; text-align: center; color: #fff; font-weight: bold;">
        Email Failed, Try Again
      </div>
    </div>

    <div id="inboxcontainer">
      <div id="labelGmail">INBOX</div>
      <table class=".table-indox tbody table table-striped">

        <tr>
          <td><b id="gmailDraftHeader">From</b></td>
          <td><b>Subject</b></td>
          <td><b>Date</b></td>
        </tr>

        <tbody id="woooow"> 

        </tbody>

      </table>
    </div>
    </div>
  </div>
  </div>

  <div class="clearfix"></div>


  <!-- OUTLOOK -->
  <div class="w-100 email-contaioner card p-2" *ngIf="tabArray[2].value == true">

    <!-- <div class="d-flex flex-row justify-content-start align-items-center" *ngIf="userInfo || profile"> -->

    
      <div class="d-flex flex-row justify-content-start align-items-center">
  
  
        <div class="authenticatedProfileData" *ngIf="profile">
          <div class="d-flex align-items-center justify-content-between" *ngIf="loginDisplay">
            <div class="d-flex align-items-center justify-content-between">
              <img src="../../../../assets/microsoft-outlook.svg" class="img-style" style="width: 30px;" />
              <small class="mb-0 ml-1 d-flex flex-column">
                {{ profile?.displayName }}
                <small>{{ profile?.mail }}</small>
              </small>
            </div>
            <div class="d-flex align-items-center justify-content-around">
              <i class="pi pi-refresh pointer mx-1" title="Refresh" (click)="ngOnInit()"></i>
              <i class="pi pi-cog pointer" title="Settings" (click)="menu.toggle($event)"></i>
            </div>
          </div>
          <p-menu #menu appendTo="body" [model]="outlookSettingsMenu" [popup]="true"></p-menu>
        </div>

        <div class="col-md-12">
          <div class="row bg-google">      
              <button class="btn btn-link pl-1 mb-2" type="button" *ngIf="!authService.instance.getAllAccounts().length"
                (click)="loginOutlook()">
                <img src="../../../../assets/ms-symbollockup_signin_dark.png" style=" min-width: 198px; width: 198px;">
              </button>
          </div>
        </div>
      </div>
    <!-- </div> -->



    <div class="row" [hidden]="!userInfo && !authService.instance.getAllAccounts().length">
      <div class="col-2 side-section">
        <div>
          <p-dropdown [options]="emailAccounts" [(ngModel)]="selectedEmailAccount" optionLabel="name"
            (onChange)="onAccountChange($event)"></p-dropdown>
        </div>
        <div [ngClass]="{
          activeButtonLine: toggleStatus === 'compose-mail',
          my_class2: toggleStatus !== 'compose-mail'
        }">
          <a class="div_align" (click)="onSelectedChange('compose-mail')" icon="folder">
            {{newEmail}}
          </a>
        </div>
        <div [ngClass]="{
          activeButtonLine: toggleStatus === 'Inbox',
          my_class2: toggleStatus !== 'Inbox'
        }">
          <a class="div_align" (click)="onSelectedChange('Inbox');"> Inbox</a>
        </div>
        <div [ngClass]="{
          activeButtonLine: toggleStatus === 'Sent Items',
          my_class2: toggleStatus !== 'Sent Items'
        }">
          <a class="div_align" (click)="onSelectedChange('Sent Items')">
            Sent Mail
          </a>
        </div>
        <div [ngClass]="{
          activeButtonLine: toggleStatus === 'Drafts',
          my_class2: toggleStatus !== 'Drafts'
        }">
          <a class="div_align" (click)="onSelectedChange('Drafts')"> Draft </a>
        </div>
        <div [ngClass]="{
          activeButtonLine: toggleStatus === 'Deleted Items',
          my_class2: toggleStatus !== 'Deleted Items'
        }">
          <a class="div_align" (click)="onSelectedChange('Deleted Items')"> Deleted </a>
        </div>
        <ng-container *ngIf="labelDropdownList?.length && selAccountType=='outlook'">
          <h5 class="pt-3 mb-0">Labels</h5>
          <hr>
          <ul class="pl-0" style="height: 230px; overflow-y: scroll;">
            <li *ngFor="let item of labelDropdownList" class="my_class2_label pl-3" [ngClass]="{
              activeButtonLine_label: toggleStatus === item.displayName,
            my_class2: toggleStatus !== item.displayName
            }" (click)="onSelectedChange(item.displayName)">{{item.displayName}}</li>
          </ul>
        </ng-container>

        <ng-container *ngIf="gmailLabelDropdownList?.length && selAccountType=='gmail'">
          <h4 class="pt-3 mb-0">Labels</h4>
          <hr>
          <ul class="pl-0" style="height: 230px; overflow-y: scroll;">
            <li *ngFor="let item of gmailLabelDropdownList" class="my_class2_label pl-3" [ngClass]="{
                activeButtonLine_label: toggleStatus === item.id,
              my_class2: toggleStatus !== item.id
            }" (click)="onSelectedChange(item.id)">{{item.name}}</li>
          </ul>
        </ng-container>


      </div>
      <div class="col-10 main-section" *ngIf="isLoadingRecords">
        <div class="h-50">
          loading....
        </div>
      </div>
      <div class="col-10 main-section" *ngIf="selAccountType=='outlook' && !isLoadingRecords">
        <div *ngIf="outlookMessageType !== 'compose-mail' && !readEmail">
          <outlook-email-client-table [emailClientTableList]="emailClientTableList"
            [emailMessageCount]="emailMessageCount" [isEmailClientTable]="isEmailClientTable"
            [headerActionType]="headerActionType" (deleteMailSection)="deleteMail($event)" [emailType]="emailType"
            (onChangeTableRowData)="selectedTableRowData($event)" (onChangeFolder)="changeFolder($event)"
            (onLabelAdd)="labelAdded($event)"
            (onPaginationChange)="onPaginationChange($event)"></outlook-email-client-table>
        </div>
        <div *ngIf="outlookMessageType === 'compose-mail' && !readEmail">
          <outlook-compose-email (deleteMailDetails)="deleteMail($event)"></outlook-compose-email>
        </div>
        <div *ngIf="readEmail">
          <outlook-email-client-detail (eventType)="onEventType($event)" [emailId]="emailId"
            (emailData)="emailId"></outlook-email-client-detail>
        </div>
      </div>
      <div class="col-10 main-section" *ngIf="selAccountType=='gmail' && !isLoadingRecords">
        <div *ngIf="emailType !== 'compose-mail' && !readEmail">
          <google-email-client-table [emailClientTableList]="emailClientTableList"
            [emailMessageCount]="emailMessageCount" [isEmailClientTable]="isEmailClientTable"
            [headerActionType]="headerActionType" (deleteMailSection)="deleteMail($event)"
            (onChangeTableRowData)="selectedTableRowData($event)" [isDisableObject]="isDisableObject"
            (onGmailLabelAdd)="gmailLabelAdded($event)" (onChangeFolder)="changeFolder($event)"
            (onGmailPaginationChange)="onGmailPaginationChange($event)"></google-email-client-table>
        </div>
        <div *ngIf="emailType === 'compose-mail' && !readEmail">
          <google-compose-email (deleteMailDetails)="deleteMail($event)"></google-compose-email>
        </div>
        <div *ngIf="readEmail">
          <google-email-client-detail (eventType)="onEventType($event)" [selRow]="selRow" (emailData)="emailId"
            [emailType]="emailType"></google-email-client-detail>
        </div>
      </div>
    </div>

    <p-dialog [(visible)]="labelPickModal" [closeOnEscape]="false" [closable]="false" [modal]="true"
      [style]="{ width: '50vw' }" class="eventDetails" [draggable]="false" [resizable]="false">
      <ng-template pTemplate="header">Choose Folder's to display in Menu</ng-template>
      <ng-template pTemplate="content" class="px-2">
        <div class="mt-3 d-flex flex-wrap py-4">
          <div class="mb-2 mt-1 pl-1" *ngFor="let label of MenuLabelDropdownList">
            <p-checkbox name="labelname" class="other" multiple [value]="label.id" [(ngModel)]="selectedLbls"
              [label]="label.displayName">
            </p-checkbox>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="footer">
        <div class="d-flex align-items-center">
          <button type="button" (click)="selectedLabels(selectedLbls)" class="btn btn-sm btn-primary">Submit</button>
        </div>
      </ng-template>
    </p-dialog>
  

  <p-dialog [(visible)]="isGcallogoutInProgress" [showHeader]="false" [closeOnEscape]="false" [closable]="false"
    [modal]="true" [style]="{ width: '30vw' }" class="eventDetails" [draggable]="false" [resizable]="false">
    <ng-template pTemplate="content">
      <div class="p-4 d-flex flex-column justify-content-center align-items-center">
        <h4>Removing calendar events & signing out google account.</h4>
        <div class="spinner-border text-danger my-3 mx-auto" style="width: 3rem;height: 3rem;" role="status"></div>
      </div>
    </ng-template>
  </p-dialog>
  </div>



<!-- COMPOSE GMAIL -->
  <p-dialog [(visible)]="compose_gmail" [showHeader]="true" [closeOnEscape]="false" [closable]="true"
    [modal]="true" [style]="{ width: '50vw' }" class="eventDetails" [draggable]="false" [resizable]="false">
    <ng-template pTemplate="content" style="position: relative;">
      
      <div class="d-flex flex-column justify-content-center align-items-center">
       
          <div class="gmailLogo">  <img src="https://ssl.gstatic.com/ui/v1/icons/mail/rfr/logo_gmail_lockup_default_1x_r5.png"></div>
          <h4 class="mb-4">Compose Email</h4>
          <form style="width: 100%; text-align: center;">
          <input type="text" class="form-control mb-2" pattern="email" required placeholder="To; Email" id="compose-to" />
          <input type="text" class="form-control mb-2" required placeholder="Subject" id="compose-subject" />
          <textarea class="form-control  mb-4" id="compose-message" required>Type your message here</textarea>
          <button onclick="sendEmail()" id="send-button"type="Submit" class="login-with-google-btn" style="border: 1px solid #cecece;
      font-weight: bold; margin: 0px auto;">
            Send Email
          </button>

          <button onclick="draftEmail()" id="draft-button" type="Submit" class="signout_button" style="margin-left: 10px; border: 1px solid #cecece;">
            Save Draft
          </button>
        </form>
      </div>

      <div  id="successEmail" style="display: none; padding: 10px; border-radius: 10px; margin: 20px auto; margin-bottom: 0px; background: #b2e2b8; border: 2px solid #5ca065; text-align: center; color: #000; font-weight: bold;">
          Email Sent Successfully
      </div>

      <div  id="draftEmail" style="display: none; padding: 10px; border-radius: 10px; margin: 20px auto; margin-bottom: 0px; background: #b2e2b8; border: 2px solid #5ca065; text-align: center; color: #000; font-weight: bold;">
        Email Saved to Draft Successfully
    </div>

      <div  id="errorEmail" style="display: none; padding: 10px; border-radius: 10px; margin: 20px auto; margin-bottom: 0px; background:#F75757; border: 2px solid #b11e2f; text-align: center; color: #fff; font-weight: bold;">
        Email Failed, Try Again
    </div>

    </ng-template>
  </p-dialog>


